import TextField from '@material-ui/core/TextField';
import React from 'react';
import { useStyles } from '../styles/Styles';

export default function ErrorAwareTextField(props) {
    const classes = useStyles(props, "text")();

    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && props.value !== props.prevValue) {
            return props.prevValue.length < 30 ? props.prevValue : props.prevValue.slice(0, 30) + '...';
        } else {
            return "";
        }
    }

    const isShrink = (v) => {
        if (v) {
            return true;
        } else {
            return false;
        }
    }

    const isError = () => {
        if (props.errors) {
            return props.errors.has(props.name);
        } else {
            return false;
        }
    }

    const { prevValue, ...rest } = props;
    return (
        <TextField
            fullWidth
            error={isError()}
            helperText={helperText()}
            variant="outlined"
            id={props.name}
            autoComplete="off"
            className={classes.root}
            InputLabelProps={{ shrink: isShrink(props.value) }}
            FormHelperTextProps={{ className: "helper-text" }}
            {...rest} />
    )
}
;